/*
 *   Copyright (c) 2021 Neller Connect Pty Ltd
 *   All rights reserved.
 *   The Spoketree Developer Framework software is distributed free of charge and limited to use for Spoketree projects only. Modification of the software without prior consent from Neller Connect Pty Ltd may affect warranty of Spoketree projects. For any other uses of the software, in original or modified form, including but not limited to distribution in whole or in part, specific prior permission must be obtained from Neller Connect Pty Ltd. The software shall not be used, rewritten, or adapted as the basis of a commercial software or hardware product without first obtaining appropriate licenses from Neller Connect Pty Ltd. Neller Connect Pty Ltd makes no representations about the suitability of the software for any other purpose.
 */

const solution = {
  organisation: {
    title: "Neller Connect",
    links: {
      home: "https://www.nellerconnect.com.au",
      about: "https://www.nellerconnect.com.au/about",
      contact: "https://www.nellerconnect.com.au/contact"
    }
  },
  system: {
    icon: '/spoketree-logo.png',
    title: 'Spoketree'
  }
}

export default solution;